import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/logo.png'


const _hoisted_1 = { class: "block p-2 max-w-xs bg-white rounded-lg border border-gray-200 shadow-md" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row gap-1 md:gap-2 font-bold pb-2 justify-start" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-sm uppercase truncate basis-8" }, "#"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-sm uppercase truncate basis-8" }, "V")
], -1)
const _hoisted_5 = { class: "flex flex-col" }

import { useStore } from "@/stores/game";
import gameRound from "./gameRound.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'gameRounds',
  setup(__props) {

const game = useStore();
const rounds = game.rounds;

function reset() {
    var txt;
    if (confirm("Wil je een nieuw spel starten?")) {
      game.reset()
    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", {
        class: "mb-2 text-2xl font-bold tracking-tight text-blue dark:text-white uppercase text-ellipsis truncate h-8",
        style: {"cursor":"pointer"},
        onClick: _cache[0] || (_cache[0] = ($event: any) => (reset()))
      }, _hoisted_3),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rounds), (round, index) => {
          return (_openBlock(), _createBlock(gameRound, {
            key: index,
            round: round,
            roundIndex: index
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(round.id), 1)
            ]),
            _: 2
          }, 1032, ["round", "roundIndex"]))
        }), 128))
      ])
    ])
  ]))
}
}

})